import { render, staticRenderFns, recyclableRender, components } from "./creationCenter.vue?vue&type=template&id=174d7374&scoped=true&"
var renderjs
import script from "./creationCenter.vue?vue&type=script&lang=js&"
export * from "./creationCenter.vue?vue&type=script&lang=js&"
import style0 from "./creationCenter.vue?vue&type=style&index=0&id=174d7374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174d7374",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/creationCenter/creationCenter.vue"
export default component.exports